import { render, staticRenderFns } from "./baptis.vue?vue&type=template&id=0d462278&"
import script from "./baptis.vue?vue&type=script&lang=js&"
export * from "./baptis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports